var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetDemandLimits(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6914 12.0335L13.1091 3.48312C12.9407 3.3357 12.709 3.3357 12.5405 3.48312L8.91821 6.7053V4.85202C8.91821 4.62036 8.72867 4.43082 8.49701 4.43082H6.58056C6.3489 4.43082 6.15936 4.62036 6.15936 4.85202V9.19037L2.9793 12.0335C2.68446 12.2862 2.874 12.7706 3.25308 12.7706H5.0853V20.7312C5.0853 20.9629 5.27484 21.1524 5.5065 21.1524H20.1432C20.3748 21.1524 20.5644 20.9629 20.5644 20.7312V12.7706H22.3966C22.7967 12.7706 22.9863 12.2862 22.6914 12.0335ZM16.0575 13.0654L12.2036 18.2251C11.8666 18.6674 11.1506 18.3515 11.2559 17.8039L11.9298 14.4764H10.0133C9.57107 14.4764 9.33941 13.992 9.59213 13.634L13.4672 8.47434C13.8041 8.03208 14.5202 8.34798 14.4149 8.89553L13.7409 12.223H15.6574C16.0786 12.223 16.3313 12.7074 16.0575 13.0654Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetDemandLimits);
export default __webpack_public_path__ + "static/media/net-demand-limits.16250d73.svg";
export { ForwardRef as ReactComponent };